module.exports = __webpack_public_path__ + "media/images/stat__background-b5e9c859fabd6e762039d9f2d74cc6aa.jpg";